import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import { Headersubfull } from "components/GenericComponent/HeaderSubFull/headersubfull";
import { useSelector, useDispatch } from "react-redux";

export const PageThankYou = () => {
  return (
    <Layout>
      <div class="Page-Thank jumbotron1">
        <div className="form-Thank">
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <div class="form-iconTB">
              <div class="form-cir">
                <i class="la la-check-circle"></i>
              </div>
            </div>
            <p class="text-titleTB">Giao dịch thành công!</p>
            <p class="text-MainTB">
              Cảm ơn bạn đã sử dụng dịch vụ cung cấp thông tin tín dụng của
              Morman. Thông tin bạn chọn sẽ được chuyển vào tài khoản ngay lập
              tức. Hãy kiểm tra danh sách dữ liệu đã mua nhé!
            </p>
            <div className="form-tt">
              <div className="row-tt-bg">
                <span>Mã thông tin</span>
                <span>fsadf</span>
              </div>
              <div className="row-tt">
                <span>Thời gian đăng ký vay</span>
                <span>fsadf</span>
              </div>
              <div className="row-tt">
                <span>Họ và tên</span>
                <span>fsadf</span>
              </div>
              <div className="row-tt">
                <span>Địa chỉ</span>
                <span>fsadf</span>
              </div>
              <div className="row-tt">
                <span>Số tiền vay</span>
                <span>fsadf</span>
              </div>
              <div className="row-tt">
                <span>Điện thoại</span>
                <span>fsadf</span>
              </div>
            </div>
            <p class="lead hotline-text">
              Có bất kỳ vấn đề gì cần hỗ trợ hãy liên hệ với chúng tôi qua số
              điện thoại: <a href="callto://+0981528850">0981 528 850</a>
              <br />
              <span class="thank-u">Xin cám ơn!</span>
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};
